// extracted by mini-css-extract-plugin
export default {"headerText":"QuestionExplanation_headerText__q0VMA","explanationText":"QuestionExplanation_explanationText__E2VpM"};